// extracted by mini-css-extract-plugin
export default {"becomeDealerPage":"style_becomeDealerPage__n3ghI","becomeDealerInner":"style_becomeDealerInner__NnJAK","loaderBox":"style_loaderBox__0dpkJ","successBox":"style_successBox__C6xKM"};